import { defineStore } from "pinia";

export const useGuideIdStore = defineStore("guideid", {
	state: () => {
		return { guideid: null as null | number }
	},
	actions: {
		insert(id: number | null) {
			this.guideid = id;
		}
	}
})